import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from '../../services/users.service'

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss']
})
export class PortalComponent implements OnInit {

  constructor(private usersService: UsersService, private router: Router) {
  }

  ngOnInit() {
    const typeUser = this.usersService.getUserType();
    if (typeUser != '') {
      this.router.navigate(['/accueil/' + typeUser]);
    }
  }

}
